import AbstractAnalyticsInjector from '@/analytics/AbstractAnalyticsInjector'
import zenkyEvents from "@/events";

export default class VkPixel extends AbstractAnalyticsInjector {
  getEvents() {
    return {
      [zenkyEvents.CALLBACK_SUBMITTED]: 'contact',
      [zenkyEvents.FEEDBACK_SUBMITTED]: 'contact',
      [zenkyEvents.ORDER_SUBMISSION_STARTED]: 'initiate_checkout',
      [zenkyEvents.PRODUCT_ADDED_TO_ORDER]: 'add_to_cart',
      [zenkyEvents.ORDER_SUBMITTED]: 'purchase',
    };
  }

  load(id, config, head) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = 'https://vk.com/js/api/openapi.js?168'
      script.onload = () => resolve()
      script.onerror = err => reject(err)

      head.appendChild(script)
    })
  }

  init(config) {
    if (typeof window.VK === 'undefined') {
      return false
    }

    window.VK.Retargeting.Init(this.accountId)
    window.VK.Retargeting.Hit()

    return true
  }

  handleEvent(event, externalEvent, payload) {
    console.log(`[VkPixel] Got event "${event}"`, { externalEvent, payload });

    window.VK.Goal(
      externalEvent,
      this.getGoalParams(event, payload),
    );
  }

  getGoalParams(event, payload) {
    let value = null;

    switch (event) {
      case zenkyEvents.ORDER_SUBMISSION_STARTED:
      case zenkyEvents.ORDER_SUBMITTED:
        value = parseInt(payload?.order?.total_price?.value / 100 || '0', 10);
        break;
      case zenkyEvents.PRODUCT_ADDED_TO_ORDER:
        value = parseInt(payload?.variant?.price?.value / 100 || '0', 10);
        break;
    }

    if (value > 0) {
      return { value };
    }

    return {};
  }
}
